module.exports = __webpack_public_path__ + "static/media/number-plate_bike_full.fec75efc.png";